// @ts-expect-error
import Bacon from 'baconjs';

// @ts-expect-error
import {Dispatcher} from '../infrastructure/dispatcher';

import {listFactory} from './list';

// Don't really have a good way of typing this.  :(
type BaconStream = any;

/**
 * @todo Map entity type to display name
 */
/**
 * Factory function used by each of the entity types to produce their stateful
 * stream.
 *
 * @param  {string} entityType - One of accounts, contacts, leads.
 * @param  {string} displayName - One of companies, leads, people
 * @param  {string} displayNameSingular - One of company, lead, person
 * @param  {stream} listUrlStream - A stream of all of url data passed specific
 *                  to the entity
 * @param  {string[]} defaultFields - A list of the default fields for this
 *                    entity
 * @return {Bacon.Property} - A stateful stream that includes all of the data for the
 *                      web filtering list
 */
// @ts-expect-error
function entities(entityType, displayName, displayNameSingular, listUrlStream, defaultFields) {
    const dispatcher = new Dispatcher();
    dispatcher.plug('URL', listUrlStream);

    return Bacon.combineTemplate({
        entityType: entityType,
        displayName: displayName,
        displayNameSingular: displayNameSingular,
        list: listFactory(`${entityType}`, dispatcher, {
            topLevelEntity: entityType,
            defaultFields,
        }),
    });
}

export function accounts(listUrlStream: BaconStream) {
    return entities('accounts', 'companies', 'company', listUrlStream, {
        accounts: ['name', 'contacts', 'lastContactedTime', 'address', 'accountType', 'tags'],
    });
}

export function contacts(listUrlStream: BaconStream) {
    return entities('contacts', 'people', 'person', listUrlStream, {
        contacts: [
            'name',
            'lastContactedTime',
            'email',
            'phone',
            'address',
            'tags',
            'marketingStatus',
        ],
    });
}

export function leads(listUrlStream: BaconStream) {
    return entities('leads', 'leads', 'lead', listUrlStream, {
        leads: [
            'name',
            'createdTime',
            'value',
            'owner',
            'milestone',
            'confidence',
            'closedTime',
            'sources',
        ],
    });
}
